export default {
  common: {
    appName: 'ElderCare',
    loading: 'Chargement...',
    retry: 'Réessayer',
    goBack: 'Accueil',
    logout: 'Déconnexion',
    save: 'Enregistrer',
    cancel: 'Annuler',
    confirm: 'Confirmer',
    delete: 'Supprimer',
    edit: 'Modifier',
    search: 'Rechercher',
    weekDays: {
      sun: 'Dim',
      mon: 'Lun',
      tue: 'Mar',
      wed: 'Mer',
      thu: 'Jeu',
      fri: 'Ven',
      sat: 'Sam',
    },
  },
  nav: {
    home: 'Accueil',
    login: 'Connexion',
    dashboard: 'Tableau de bord',
    health: 'Santé',
    medication: 'Médicaments',
    sos: 'Urgence',
    family: 'Famille',
    article: 'Articles',
    checkin: 'Enregistrement',
    settings: 'Paramètres',
    about: 'À propos',
  },
  footer: {
    rights: 'Tous droits réservés',
    privacy: 'Politique de confidentialité',
    terms: "Conditions d'utilisation",
  },
  index: {
    hero: {
      title: 'ElderCare - Gardien de santé intelligent pour seniors',
      subtitle: 'Plateforme de gestion de santé conçue pour les personnes âgées, permettant aux familles de rester informées et aux seniors de rester en bonne santé',
      cta: 'Commencer',
      learnMore: 'En savoir plus',
    },
    features: {
      title: 'Fonctionnalités principales',
      health: { title: 'Suivi santé', desc: 'Surveillez tension artérielle, glycémie et fréquence cardiaque avec des alertes intelligentes' },
      medication: { title: 'Gestion des médicaments', desc: 'Rappels de prise et vérification des interactions médicamenteuses, plus jamais d\'oubli' },
      sos: { title: 'Appel d\'urgence', desc: 'SOS en une touche, notification automatique de la famille et partage de localisation' },
      family: { title: 'Soin familial', desc: 'Surveillance à distance, alertes instantanées et partage de données pour les familles' },
      article: { title: 'Articles santé', desc: 'Connaissances sanitaires fiables et guides de bien-être personnalisés' },
      checkin: { title: 'Enregistrement quotidien', desc: 'Suivi quotidien simple pour construire des habitudes saines' },
    },
    elderly: {
      title: 'Conception adaptée aux seniors',
      desc: 'Conçu pour les seniors : facile à utiliser, à voir et à toucher',
      font: 'Grandes polices',
      touch: 'Grandes zones tactiles',
      contrast: 'Couleurs à haut contraste',
    },
  },
  login: {
    title: 'ElderCare',
    loginTab: 'Connexion',
    registerTab: 'Inscription',
    name: 'Nom',
    email: 'Email',
    password: 'Mot de passe',
    role: 'Je suis',
    elderRole: 'Senior',
    familyRole: 'Famille',
    bindCode: 'Code de liaison',
    bindCodeHint: 'Entrez le code de liaison du compte senior pour vous associer et accéder aux données de santé',
    loginBtn: 'Connexion',
    registerBtn: 'Inscription',
    verifyHint: 'Un email de vérification sera envoyé à votre adresse après inscription',
    error: 'Échec de l\'opération, veuillez réessayer',
    nameTooShort: 'Le nom doit contenir au moins 2 caractères',
    emailInvalid: 'Veuillez entrer une adresse e-mail valide',
    passwordTooShort: 'Le mot de passe doit contenir au moins 8 caractères',
  },
  dashboard: {
    title: 'Tableau de bord santé',
    metrics: {
      bloodPressure: 'Tension artérielle',
      bloodSugar: 'Glycémie',
      heartRate: 'Fréquence cardiaque',
      weight: 'Poids',
      sleep: 'Sommeil',
      temperature: 'Température',
    },
    quickActions: 'Actions rapides',
    recordHealth: 'Enregistrer santé',
    takeMedicine: 'Prendre médicament',
    sos: 'Appel d\'urgence',
    checkinStatus: 'Enregistrement du jour',
    checkedIn: 'Enregistré aujourd\'hui',
    notCheckedIn: 'Non enregistré aujourd\'hui',
    goCheckin: 'S\'enregistrer',
    medicationReminders: 'Rappels de médicaments',
    noReminders: 'Aucun rappel de médicaments',
    taken: 'Pris',
  },
  health: {
    title: 'Dossiers santé',
    inputTitle: 'Saisie de données',
    systolic: 'Systolique (mmHg)',
    diastolic: 'Diastolique (mmHg)',
    bloodSugar: 'Glycémie (mmol/L)',
    heartRate: 'Fréquence cardiaque (bpm)',
    weight: 'Poids (kg)',
    sleepHours: 'Sommeil (heures)',
    temperature: 'Température (°C)',
    submit: 'Soumettre l\'enregistrement',
    trend: 'Tendances',
    days: 'jours',
    aiAnalysis: 'Analyse santé par IA',
    analyze: 'Analyser',
    noAnalysis: 'Cliquez sur le bouton ci-dessus pour obtenir un rapport d\'analyse santé par IA',
    history: 'Historique',
    noHistory: 'Aucun historique',
    chartLabelSystolic: 'Pression systolique',
    atLeastOneField: 'Veuillez remplir au moins une donnée de santé',
  },
  medication: {
    title: 'Gestion des médicaments',
    currentPlan: 'Plan actuel',
    noMedications: 'Aucun médicament',
    addMedication: 'Ajouter un médicament',
    name: 'Nom du médicament',
    dosage: 'Dosage',
    frequency: 'Fréquence',
    freqDaily: 'Une fois par jour',
    freqTwice: 'Deux fois par jour',
    freqThree: 'Trois fois par jour',
    freqWeekly: 'Une fois par semaine',
    time: 'Heure de prise',
    startDate: 'Date de début',
    addBtn: 'Ajouter',
    interactionWarning: 'Alerte d\'interaction médicamenteuse',
    noInteraction: 'Aucun risque d\'interaction médicamenteuse',
    calendar: 'Calendrier de médicaments',
    invalidTimeFormat: 'Format d\'heure invalide, utilisez HH:mm (ex., 08:00, 20:00)',
  },
  sos: {
    title: 'Appel d\'urgence',
    holdToCall: 'Maintenir pour appeler',
    holdHint: 'Maintenir 1 seconde pour déclencher l\'appel d\'urgence',
    sent: 'Appel d\'urgence envoyé',
    sentDesc: 'Vos contacts d\'urgence ont été notifiés. Restez calme et attendez de l\'aide',
    contacts: 'Contacts d\'urgence',
    location: 'Position actuelle',
    loadingLocation: 'Localisation en cours...',
    locationUnavailable: 'Localisation indisponible',
    history: 'Historique SOS',
    noHistory: 'Aucun enregistrement SOS',
    confirmed: 'Confirmé',
    pending: 'En attente',
  },
  family: {
    title: 'Soin familial',
    members: 'Famille associée',
    noMembers: 'Aucun membre familial associé',
    bindCode: 'Code de liaison',
    bindCodeHint: 'Partagez ce code avec vos proches pour associer vos comptes',
    invite: 'Inviter un proche',
    email: 'Email familial',
    relationship: 'Relation',
    relSon: 'Fils',
    relDaughter: 'Fille',
    relSpouse: 'Conjoint',
    relSibling: 'Frère/Sœur',
    relOther: 'Autre',
    inviteBtn: 'Envoyer l\'invitation',
    notifications: 'Préférences de notification',
    prefAbnormal: 'Alerte santé anormale',
    prefMedication: 'Rappel de médicaments',
    prefSos: 'Alerte d\'urgence',
    prefWeekly: 'Rapport hebdomadaire',
    prefCheckin: 'Notification d\'enregistrement',
    dataSharing: 'Partage de données',
    shareDesc: 'Autoriser la famille à consulter vos données de santé',
    inviteSent: 'Invitation envoyée avec succès',
    inviteFailed: 'Échec de l\'envoi de l\'invitation, veuillez réessayer',
    invalidEmail: 'Veuillez entrer une adresse e-mail valide',
  },
  article: {
    title: 'Articles santé',
    search: 'Rechercher des articles...',
    noArticles: 'Aucun article trouvé',
    expand: 'Lire la suite',
    collapse: 'Réduire',
    categories: {
      all: 'Tous',
      heart: 'Cardiovasculaire',
      diabetes: 'Diabète',
      bone: 'Os',
      sleep: 'Sommeil',
      nutrition: 'Nutrition',
      exercise: 'Exercice',
    },
  },
  checkin: {
    title: 'Enregistrement quotidien',
    feeling: 'Comment vous sentez-vous ?',
    feelings: {
      great: 'Excellent',
      good: 'Bien',
      normal: 'Normal',
      bad: 'Mauvais',
      terrible: 'Très mauvais',
    },
    medication: 'Médicaments aujourd\'hui',
    yes: 'Oui',
    no: 'Non',
    diet: 'Évaluation de l\'alimentation',
    dietRatings: {
      good: 'Bonne',
      normal: 'Normale',
      poor: 'Mauvaise',
    },
    exercise: 'Exercice aujourd\'hui',
    mood: 'Humeur du jour',
    submit: 'Soumettre l\'enregistrement',
    streak: 'Série en cours',
    streakDays: 'jours',
    calendar: 'Calendrier d\'enregistrement',
  },
  settings: {
    title: 'Paramètres',
    profile: 'Profil',
    name: "Nom d'utilisateur",
    phone: 'Téléphone',
    birthday: 'Date de naissance',
    emergencyContact: 'Contact d\'urgence',
    save: 'Enregistrer les modifications',
    preferences: 'Préférences',
    language: 'Langue',
    theme: 'Thème',
    light: 'Clair',
    dark: 'Sombre',
    notifications: 'Notifications',
    notifHealth: 'Alertes santé',
    notifMedication: 'Rappels de médicaments',
    notifSos: 'Alertes d\'urgence',
    notifCheckin: 'Rappels d\'enregistrement',
    bindCode: 'Mon code de liaison',
    changePassword: 'Changer le mot de passe',
    currentPassword: 'Mot de passe actuel',
    newPassword: 'Nouveau mot de passe',
    changePasswordBtn: 'Changer le mot de passe',
    dangerZone: 'Zone dangereuse',
    deleteDesc: 'La suppression du compte est irréversible. Toutes les données seront perdues',
    deleteAccount: 'Supprimer le compte',
    deleteConfirm: 'Êtes-vous sûr ? Cette action est irréversible !',
  },
  about: {
    title: 'À propos d\'ElderCare',
    subtitle: 'Gardien de santé intelligent pour seniors',
    intro: 'Présentation',
    introContent: 'ElderCare est une plateforme de gestion de santé conçue pour les seniors, intégrant un suivi santé intelligent, la gestion des médicaments, les appels d\'urgence et bien plus, pour aider les seniors à gérer leur santé tout en restant connectés avec leur famille.',
    version: 'Informations de version',
    versionNumber: 'Numéro de version',
    buildDate: 'Date de compilation',
    acknowledgements: 'Remerciements',
    contact: 'Contact',
    contactEmail: "q3300404157{'@'}gmail.com",
    privacy: 'Politique de confidentialité',
    terms: "Conditions d'utilisation",
  },
  notfound: {
    message: 'Désolé, la page que vous cherchez n\'existe pas',
    goHome: 'Retour à l\'accueil',
  },
  privacy: {
    title: 'Politique de confidentialité',
    sections: {
      collection: {
        title: 'Collecte d\'informations',
        content: 'Nous ne collectons que les informations personnelles nécessaires à la fourniture de nos services, y compris les données d\'inscription (email, nom), les données de santé (tension artérielle, glycémie et autres indicateurs) et les informations sur l\'appareil. Nous ne collectons aucune information personnelle sans rapport avec nos services.',
      },
      usage: {
        title: 'Utilisation des informations',
        content: 'Vos informations personnelles sont uniquement utilisées pour fournir et améliorer nos services, notamment l\'analyse des données de santé, les alertes d\'anomalie, les rappels de médicaments et autres fonctionnalités essentielles. Nous n\'utiliserons pas vos informations à des fins non autorisées.',
      },
      storage: {
        title: 'Stockage des informations',
        content: 'Vos données sont stockées sur des serveurs cloud sécurisés avec transmission et stockage chiffrés. Nous prenons des mesures techniques raisonnables pour protéger la sécurité de vos données et empêcher tout accès non autorisé.',
      },
      sharing: {
        title: 'Partage des informations',
        content: 'Sans votre consentement explicite, nous ne partagerons vos informations personnelles avec aucun tiers. Les données de santé ne seront partagées avec les membres de la famille associée qu\'après votre autorisation de connexion familiale.',
      },
      rights: {
        title: 'Vos droits',
        content: 'Vous avez le droit d\'accéder, de corriger et de supprimer vos informations personnelles, ainsi que de retirer votre consentement. Vous pouvez exercer ces droits via les paramètres de l\'application ou en contactant notre équipe de support.',
      },
      security: {
        title: 'Sécurité',
        content: 'Nous utilisons le chiffrement et les mesures de sécurité conformes aux normes du secteur pour protéger vos données, notamment la transmission chiffrée SSL, le stockage chiffré des données et le contrôle d\'accès. Nous examinons et mettons à jour régulièrement nos mesures de sécurité.',
      },
    },
  },
  terms: {
    title: "Conditions d'utilisation",
    sections: {
      acceptance: {
        title: 'Acceptation des conditions',
        content: 'En utilisant cette application, vous acceptez de vous conformer aux présentes conditions d\'utilisation. Si vous n\'acceptez pas l\'une quelconque de ces conditions, veuillez cesser d\'utiliser cette application. Nous nous réservons le droit de modifier ces conditions à tout moment.',
      },
      service: {
        title: 'Description du service',
        content: 'ElderCare fournit des services d\'assistance à la gestion de la santé, notamment l\'enregistrement des données de santé, les rappels de médicaments, les appels d\'urgence et autres fonctionnalités. Ce service est fourni à titre indicatif uniquement et ne constitue pas un avis médical, ni ne peut remplacer des services médicaux professionnels.',
      },
      accounts: {
        title: 'Gestion des comptes',
        content: 'Vous devez créer un compte pour utiliser les fonctionnalités essentielles de cette application. Vous êtes responsable de la sécurité de votre mot de passe et de toutes les activités effectuées sous votre compte. Si vous constatez une utilisation non autorisée de votre compte, veuillez nous en informer immédiatement.',
      },
      data: {
        title: 'Données et confidentialité',
        content: 'Nous accordons une grande importance à la protection de votre vie privée. Pour les règles détaillées de traitement des données, veuillez consulter notre Politique de confidentialité. Vous conservez un contrôle total sur les données de santé que vous soumettez.',
      },
      liability: {
        title: 'Limitation de responsabilité',
        content: 'Les informations de santé fournies par cette application sont données à titre indicatif uniquement et ne constituent pas un diagnostic ou un conseil de traitement médical. Nous ne sommes pas responsables des pertes résultant de l\'utilisation des informations de cette application. En cas de problème de santé, veuillez consulter un professionnel de santé qualifié.',
      },
      changes: {
        title: 'Modifications des conditions',
        content: 'Nous pouvons mettre à jour les présentes conditions d\'utilisation de temps à autre. Les modifications importantes vous seront communiquées par notification dans l\'application ou par email. L\'utilisation continue de cette application constitue une acceptation des conditions mises à jour.',
      },
    },
  },
  feedback: {
    title: 'Commentaires',
    subtitle: 'Vos commentaires sont très importants pour nous',
    name: 'Nom',
    namePlaceholder: 'Entrez votre nom (facultatif)',
    email: 'E-mail',
    emailPlaceholder: 'Entrez votre e-mail',
    subject: 'Sujet',
    subjectGeneral: 'Commentaire général',
    subjectBug: 'Rapport de bug',
    subjectFeature: 'Suggestion de fonctionnalité',
    subjectOther: 'Autre',
    message: 'Message',
    messagePlaceholder: 'Décrivez vos commentaires en détail...',
    submit: 'Envoyer',
    submitting: 'Envoi en cours...',
    success: 'Commentaires envoyés avec succès ! Merci pour votre contribution',
    error: 'Échec de l\'envoi, veuillez réessayer plus tard',
  },
  verify: {
    loading: 'Vérification de votre e-mail...',
    success: 'Vérification réussie !',
    successDesc: 'Votre e-mail a été vérifié. Vous pouvez maintenant vous connecter',
    failed: 'Échec de la vérification',
    failedDesc: 'Le lien de vérification est invalide ou expiré. Veuillez renvoyer l\'e-mail de vérification',
    resend: 'Renvoyer l\'e-mail de vérification',
    resending: 'Envoi en cours...',
    goLogin: 'Aller à la connexion',
  },
  theme: {
    light: 'Clair',
    dark: 'Sombre',
  },
}
